import React, { useState, useEffect, useRef, useMemo } from 'react';
import Chart from 'react-apexcharts';
import { DocumentPanelContainer, RecordContainter } from './styles';
import { Link } from 'react-router-dom';
import { Button, message, Card, Avatar, Icon, Tooltip, Popconfirm, Divider } from 'antd';
import SearchSelectObject from '../../../../components/ReusableComponents/SearchSelectObject';
import { SEARCHABLE_TABLE, STATUS_MONITORING, DOCUMENT_PANEL as trans } from '../TranslationValues';
import { withTranslation } from 'react-i18next';
import { PrintingModal } from '../../../../utils/complexDocumentConstants';
import { formatDataForApexBarChart, transformMetaSearchFilter, transformMetaSearchKeys, transformRemovedTagFilters, getChannelTotals,mergeFields } from '../../../../utils/helper';
import { getAllLanguage } from '../../../../utils/services/languageApi';
import { channels, metaSearchKeyMappings, stageStatus } from '../../../../utils/constants/statusMonitoring';
import { getSearchMetaKeys, postExclusions, getExclusions, fetchExclusionsData,getJobRecords } from '../../../../utils/services/statusMonitoringAPI';
import { getUser } from '../../../../utils/services/userAPI';
import moment from 'moment';

const namespaces = ['SEARCHABLE_TABLE', 'DOCUMENT_PANEL'];

const defaultPrintSearchStatus = [
  { fieldName: 'status', value: 'success' },
  {
    fieldName: 'channel',
    value: 'print',
  },
];

const DocumentPanel = ({ jobId, activeItem, t, contentType, setStatsFilter, chartRef, barChartRef,totalStats, setRemovedRecord, setFailureRecord,  staticStatsKeys=[], statsKeys = [], statsFilter, setExclusionHistory, reloadSync, setReloadSync}) => {
  const [languageList, setLanguageList] = useState([]);
  const keyNames = metaSearchKeyMappings(t);
  const {barChartData, categories} = formatDataForApexBarChart(JSON.parse(activeItem?.languageStats)?.print || [], t, languageList, contentType);
  const [searchMetaKeys, setSearchMetaKeys] = useState([]);
  const toggleDataPointPreventRerenderRef = useRef(false);
  const [valueDataSet, setValueDataSet] = useState({
    [metaSearchKeyMappings(t).channel]: channels(t),
    [metaSearchKeyMappings(t).status]: stageStatus(t),
  });
  const [metaKeyRefs, setMetaKeyRefs] = useState({});
  const [removedTags, setRemovedTags] = useState([]);
  const [users, setUsers] = useState([]);
  const allowValuesforKeys = [
    metaSearchKeyMappings(t).channel,
    metaSearchKeyMappings(t).language,
    metaSearchKeyMappings(t).status,
  ];
  const batchStats = activeItem?.batchStats || [];
  const channelTotals = useMemo(() => getChannelTotals(batchStats, false, t, true) , [batchStats]);
  const [exclusionAudit, setExclusionAudit] = useState([]);
  const [removedRecordsCount, setRemovedRecordsCount] = useState(0);
  const [exclusionCount, setExclusionCount] = useState(0);
  const [exclusionFilters, setExclusionFilters] = useState([]);
  
  const stateRef = React.useRef(statsFilter);
  useEffect(() => {
    stateRef.current = statsFilter;
  }, [statsFilter]);

  const chartData = {
    series: [totalStats.success, totalStats.failure],
    options: {
      labels: stageStatus(t).map(status => status.key),
      colors: ['#C8E066', '#35346A', '#6CE5E8',],
      plotOptions: {
        pie: {
          expandOnClick: false,
          donut: {
            size: '50%',
          },
        },
      },
      dataLabels: {
        enabled: false,
      },
      legend: {
        show: true,
        position: 'bottom',
        horizontalAlign: 'center',
        floating: false,
        offsetY: 0,
        offsetX: 0,
        formatter: function(val, opts) {
          console.log({ val, opts });
          return (
            '<span style="font-family: Lato"><strong>' +
            val +
            ': ' +
            opts.w.globals.series[opts.seriesIndex] +
            '</strong></span>'
          );
        },
      },
      tooltip: {
        enabled: false,
      },
      chart: {
        events: {
          dataPointSelection: function(event, chartContext, opts) {
            let updatedList = [...stateRef.current];
            const labels = opts.w.config.labels;
            const dataPointIndex = opts.dataPointIndex;

            if (!updatedList.some(item => item.value === labels[dataPointIndex])) {
              updatedList.push({
                key: keyNames.status,
                value: labels[dataPointIndex],
              });
            } else {
              updatedList = updatedList.filter(item => item.value !== labels[dataPointIndex]);
            }
            setStatsFilter(updatedList);
          },
        },
      },
      states: {
        active: {
          allowMultipleDataPointsSelection: true,
          filter: {
            type: 'darken',
          },
        },
      },
    },
  };

  const BarData = {
    options: {
      chart: {
        type: 'bar',
        events: {
          dataPointSelection: (event, chartContext, config) => {
            if (!toggleDataPointPreventRerenderRef.current) {
              toggleDataPointPreventRerenderRef.current = true;
              const seriesIndex = config.seriesIndex;
              const dataPointIndex = config.dataPointIndex;
              const selectedLabel = config.w.globals.labels[dataPointIndex];

              let updatedList = [...stateRef.current];

              if (!updatedList.some(item => item.value === selectedLabel)) {
                updatedList.push({ key: keyNames.language, value: selectedLabel,seriesIndex:seriesIndex });
              } else {
                updatedList = updatedList.filter(item => item.value !== selectedLabel);
              }

              stateRef.current = updatedList;
              setStatsFilter(stateRef.current);
              chartContext.toggleDataPointSelection(seriesIndex === 0 ? 1 : 0, dataPointIndex);
            } else {
              toggleDataPointPreventRerenderRef.current = false;
            }
          },
        },
        toolbar: {
          show: false,
          tools: {
            download: false,
          },
          export: {},
        },
      },
      colors: ['#C8E066', '#35346A'],
      plotOptions: {
        bar: {
          horizontal: true,
          dataLabels: {
            position: 'top',
          },
        },
      },
      dataLabels: {
        enabled: false,
        offsetX: -6,
        style: {
          fontSize: '12px',
          colors: ['#000'],
        },
        formatter: function(val) {
          if (val >= 1000000) {
            // more than one million
            return (val / 1000000).toFixed(1) + 'M';
          } else if (val >= 1000) {
            // more than one thousands
            return (val / 1000).toFixed(1) + 'k';
          } else {
            return val;
          }
        },
      },
      stroke: {
        show: true,
        width: 1,
        colors: ['#fff'],
      },
      tooltip: {
        shared: true,
        intersect: false,
        y: {
          formatter: function(val, { series, seriesIndex, dataPointIndex, w }) {
            if (val >= 1000000) {
              // more than one millions
              return (val / 1000000).toFixed(1) + 'M';
            } else if (val >= 1000) {
              // more than one thousands
              return (val / 1000).toFixed(1) + 'k';
            } else if (val < 1000) {
              // more than one thousands
              return val.toFixed(0);
            } else {
              return val;
            }
          },
        },
      },
      xaxis: {
        categories: categories,
        labels: {
          formatter: function(val) {
            if (val >= 1000000) {
              // more than one millions
              return (val / 1000000).toFixed(1) + 'M';
            } else if (val >= 1000) {
              // more than one thousands
              return (val / 1000).toFixed(1) + 'k';
            } else {
              return Math.round(val * 10)/10;
            }
          },
        },
      },
      legend: {
        onItemClick: {
          toggleDataSeries: false,
        },
        onItemHover: {
          highlightDataSeries: false,
        },
      },
      states: {
        active: {
          allowMultipleDataPointsSelection: true,
          filter: {
            type: 'darken',
          },
        },
      },
    },
  };

  const fetchRemovedRecordsCount = async exclusions => {
    if (!exclusions) {
      setRemovedRecordsCount(0);
      return;
    }

    const payload = {
      limit: 7,
      page: 1,
      jobId: jobId,
      search: [...defaultPrintSearchStatus],
      exclusions: exclusions,
    };
    const removedCount = await fetchExclusionsData(payload);
    removedCount && setRemovedRecordsCount(removedCount?.dataCount);
  };

  const handleRemoveTags = async (type, id = null) => {
    if ((type === "removed" && !removedTags.length) || (type === "included" && !id)) return;
  
    const tagsRemoved =
      type === "removed" && removedTags.length
        ? transformMetaSearchFilter(removedTags, metaKeyRefs, valueDataSet)
        : [];
  
    const payload = {
      jobId,
      exclusionAudit: [
        {
          ...(type === "removed" && { exclusion: tagsRemoved }),
          ...(type === "included" && id && { reference: id }),
          type,
        },
      ],
    };
  
    try {
      const res = await postExclusions(payload);
      if (res.statusCode === 5109 && res.data) {
        setExclusionAudit(
          transformRemovedTagFilters(res.data.exclusionAudit, valueDataSet, users, t)
        );
        setExclusionHistory(res.data.exclusions);
        setExclusionFilters(res.data.exclusions)
        message.success(type === "included" ? 'Records reverted successfully' : `Records removed successfully`);
      };
      fetchRemovedRecordsCount(res.data.exclusions)
    } catch (error) {
      console.error("Error removing tags:", error);
    }
  
    setRemovedTags([]);
  };

  useEffect(() => {
    if (!jobId) return;
  
    const fetchAllInfos = async () => {
      try {
        const [metaSearchKeys, users, allLanguages, exclusions] = await Promise.all([
          getSearchMetaKeys(jobId),
          getUser(),
          getAllLanguage(),
          getExclusions(jobId),
        ]);
  
        let valueMappingDataSet, usersList;
  
        if (metaSearchKeys.statusCode === 5002) {
          const metaKey = metaSearchKeys.data?.length
            ? [...new Set([...staticStatsKeys, ...metaSearchKeys.data])]
            : staticStatsKeys;
          const { transformedKeys, referenceKeysObject } = transformMetaSearchKeys(metaKey, t);
          setSearchMetaKeys(transformedKeys);
          setMetaKeyRefs(referenceKeysObject);
        }
  
        if (users.statusCode === 823) {
          setUsers(users.data);
          usersList= users.data;
        }
  
        if (allLanguages.statusCode === 109 && allLanguages.data) {
          const lang = allLanguages.data.map(({ name, code }) => ({ key: name, value: code }));
          valueMappingDataSet = { ...valueDataSet, [metaSearchKeyMappings(t).language]: lang };
          setValueDataSet(prev => ({ ...prev, [metaSearchKeyMappings(t).language]: lang }));
          setLanguageList(lang);
        }
  
        if (exclusions.statusCode === 5108 && exclusions.data.exclusionAudit.length) {
          setExclusionAudit(transformRemovedTagFilters(exclusions.data.exclusionAudit, valueMappingDataSet, usersList, t));
          setExclusionHistory(exclusions.data.exclusions);
          setExclusionFilters(exclusions.data.exclusions)
          exclusions.data.exclusions.length && await fetchRemovedRecordsCount(exclusions.data.exclusions);         
        };
        setReloadSync(false);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
  
    const fetchLanguages = async () => {
      try {
        const res = await getAllLanguage();
        if (res.statusCode === 109) {
          setLanguageList(res.data.map(({ name, code }) => ({ key: name, value: code })));
        }
      } catch (error) {
        console.error("Error fetching languages:", error);
      }
    };
  
    contentType === PrintingModal && reloadSync ? fetchAllInfos() : fetchLanguages();
  }, [jobId, contentType, reloadSync]);

  useEffect(() =>{ 
    return () =>{
      setReloadSync(true);
    }
  },[])

  const handlePopupVisibleChange = async()=>{
    if(!removedTags.length) return;
    const payload = {
      limit: 7,
      page: 1,
      jobId: jobId,
      search: [...defaultPrintSearchStatus, ...transformMetaSearchFilter(removedTags, metaKeyRefs, valueDataSet)],
      exclusions: exclusionFilters,
    };

    const countResponse = await getJobRecords(payload);
    countResponse && setExclusionCount(countResponse?.dataCount);
  };
  
  return (
    <>
    { 
    channelTotals.print > 0 ? ( <DocumentPanelContainer disablePopConfirmButton={exclusionCount===0}>
      {contentType === PrintingModal && (
        <div className="filter-container">
          <p style={{ fontSize: '14px', fontWeight: 400 }}>
            {t(trans.SEARCH_REMOVED_DOCUMENTS.key, trans.SEARCH_REMOVED_DOCUMENTS.value)}
          </p>
          <p>
            <Link
            // disabled={removedRecordsCount === 0}
              onClick={() => {
                setFailureRecord(false);
                setRemovedRecord(true);
              }}
            >
              {t(trans.VIEW_REMOVED_RECORDS.key, trans.VIEW_REMOVED_RECORDS.value)}
            </Link>{' '}
            <span className="italic-font">
               {removedRecordsCount} {t(trans.REMOVED_RECORDS_COUNT.key, trans.REMOVED_RECORDS_COUNT.value)}
            </span>
          </p>
          <SearchSelectObject
            keyDataSet={searchMetaKeys}
            placeholder={t(
              SEARCHABLE_TABLE.SEARCH_EXACT_METADATA_PLACEHOLDER.key,
              SEARCHABLE_TABLE.SEARCH_EXACT_METADATA_PLACEHOLDER.value,
            )}
            showSelectedKeys={false}
            isDynamicKeyValue={true}
            selectedFilters={removedTags}
            setSelectedFilters={setRemovedTags}
            statsKeys={statsKeys}
            valueDataSet={valueDataSet}
            allowValuesforKeys={allowValuesforKeys}
            fullWidth={true}
          />
             <Popconfirm
                title={`Are you sure? ${exclusionCount} record will be removed.`}
                okText={'yes'}
                cancelText={'cancel'}
                placement="left"
                trigger="click"                
                okButtonProps={{ style: { display: exclusionCount === 0 ? 'none' : '' } }}    
                onConfirm={() => {
                  handleRemoveTags('removed');
                  setExclusionCount(0);
                }}
                onVisibleChange={handlePopupVisibleChange}                
                overlayStyle={{ width: 350 }}
                disabled={!removedTags.length}
              >
                <Button className="filter-button">
                  {t(trans.REMOVE_FROM_JOB.key, trans.REMOVE_FROM_JOB.value)}
                </Button>
              </Popconfirm>
          <RecordContainter>
            {[...exclusionAudit].reverse().map(({ exclusion, type, doneBy, doneOn, isRemovedIncluded, id }, i) => (
              <Card key={i} className="animate" hoverable={false} style={{ position: "relative" }}>
                <div style={{ display: "flex", gap: "6px", flexWrap: "wrap" }}>
                  {exclusion.map(({ key, value }) => (
                    <div key={`${key}-${value}`} className="filtered-key">
                      {key} : {value}
                    </div>
                  ))}

                    <span className="card-bottom">
                      <span className="removed-info">
                        {type} by {doneBy} on {moment(doneOn).format("YYYY-MM-DD HH:mm")}
                      </span>

                    {!isRemovedIncluded && (
                      <Tooltip title="Revert back the removed filter tags">
                              <Popconfirm
                                title={'Are you sure you want to revert this?'}
                                okText={'yes'}
                                cancelText={'cancel'}
                                placement="left"
                                trigger="click"
                                onConfirm={() => {
                                  handleRemoveTags('included', id);
                                }}
                                overlayStyle={{ width: 350 }}
                              >
                                <span className="roll-back">
                                  <Icon type="rollback" /> Revert
                                </span>
                            </Popconfirm>
                      </Tooltip>
                    )}
                  </span>
                </div>
              </Card>
            ))}
          </RecordContainter>
          <Divider style={{margin:'5px 0'}}/>
          <p>
            <Link
              onClick={() => {
                setRemovedRecord(false);
                setFailureRecord(true);
              }}
            >
              {t(trans.VIEW_FAILURE_RECORDS.key, trans.VIEW_FAILURE_RECORDS.value)}
            </Link>
          </p>
        </div>
      )}
      {contentType !== PrintingModal && <><div className="chart-wrapper">
          <p className="chart-title">{t(trans.FAILURE_STATS.key, trans.FAILURE_STATS.value)}</p>
          <Chart
            ref={chartRef}
            type="donut"
            options={activeItem ? chartData.options : {}}
            series={activeItem ? chartData.series : []}
            width={'100%'}
          />
        </div>
        <div className="chart-wrapper">
          <div className='chart-container'>
            <p className="chart-title">{t(trans.LANGUAGES_STATS.key, trans.LANGUAGES_STATS.value)}</p>
            <Chart
              type="bar"
              ref={barChartRef}
              options={activeItem ? BarData.options : {}}
              series={activeItem ? barChartData : []}
              width={'100%'}
              height={categories.length > 3 ? 50 * categories.length :  undefined}
            />
          </div>
        </div></>}
      </DocumentPanelContainer>)
      : <h5>{t(STATUS_MONITORING.NO_RECORDS_FOUND.key, STATUS_MONITORING.NO_RECORDS_FOUND.value)}</h5>}
    </>
  );
};

export default withTranslation(namespaces)(DocumentPanel);
